/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2023-08-31 13:18:33
 * @LastEditTime : 2025-06-10 13:22:57
 * @LastEditors  : yangxr
 * @Description  : 
 * @FilePath     : \icps_fb\src\api\internetSales\otherPayment.js
 */
export const queryPage = '/icps/system/sign/dataCollection/supplierPlanDetail/other/pay/queryPage'
export const Download = '/icps/system/sign/dataCollection/supplierPlanDetail/other/pay/exportOtherPay'
export const deleteNotes = '/icps/system/sign/dataCollection/supplierPlanDetail/other/pay/batchDelete'
import request from '@/utils/request'
export function get_list_by_type(data) {
    return request({
        url: '/base/system/base/organization/get_list_by_type',
        method: 'get',
        params: data
    })
}
export function queryEngineering(data) {
    return request({
        url: '/icps/system/sign/cloudSell/notes/queryEngineering',
        method: 'get',
        params: data
    })
}
export function queryPageTicketPay(data) {
    return request({
        url: '/icps/system/sign/cloudSell/engineeringManagement/other/payee/queryPage',
        method: 'POST',
        data
    })
}
export function queryOtherTicker(data) {
    return request({
        url: '/icps/system/sign/dataCollection/supplierPlanDetail/other/pay/queryOtherTicker',
        method: 'POST',
        data
    })
}
export function queryPageTicket(data) {
    return request({
        url: '/icps/system/sign/cloudSell/collectMoney/queryPage',
        method: 'POST',
        data
    })
}
export function queryPageOtherTicket(data) {
    return request({
        url: '/icps/system/sign/cloudSell/engineeringManagement/other/payee/queryPage',
        method: 'POST',
        data
    })
}
export function get_detail_code(data) {
    return request({
        url: '/base/system/base/dictionary/get_detail_codes',
        method: 'get',
        params: data
    })
}
export function saveOrUpdate(data) {
    return request({
        url: '/icps/system/sign/dataCollection/supplierPlanDetail/other/pay/saveOrUpdate',
        method: 'POST',
        data
    })
}
export function deletePayUnit(data) {
    return request({
        url: '/icps/system/sign/cloudSell/payerUnitManage/deletePayUnit',
        method: 'POST',
        data
    })
}